import { CookieDetailsAccordionProps } from '../sub-components/cookie-details-accordion'

export const cookieDescription: CookieDetailsAccordionProps[] = [
  {
    title: 'Strictly necessary',
    description:
      'Strictly necessary cookies help make a website navigable by activating basic functions such as page navigation and access to secure website areas. Without these cookies, the website would not be able to work properly.',
    cookies: [
      {
        dataProcessor: 'Cloudflare',
        purpose:
          'This cookie is used to manage and filter incoming traffic that matches criteria associated with bots. It helps protect websites from malicious bots and automated traffic.',
        dataProcessorPrivacyPolicy: {
          label: "Cloudflare's Privacy Policy | Cloudflare",
          link: 'https://www.cloudflare.com/en-gb/privacypolicy',
        },
        expiry: 'The __cf_bm cookie expires after 30 minutes of inactivity.',
        cookieName: '__cf_bm',
        provider: 'Cloudflare',
      },

      {
        dataProcessor: 'Auth0',
        purpose:
          'This cookie is used to remember the authentication state with Auth0 across multiple page tabs and page refreshes. It helps minimize unnecessary log-ins for a better user experience.',
        dataProcessorPrivacyPolicy: {
          label: 'Auth0 Data Privacy and Compliance',
          link: 'https://auth0.com/docs/secure/data-privacy-and-compliance',
        },
        expiry:
          'This cookie is a session cookie, meaning it expires when the browser tab is closed.',
        cookieName: '_legacy_auth0.<unique_identifier>.is.authenticated',
        provider: 'Auth0',
        note: '<unique_identifier> represents a unique, auto-generated string that changes with each session',
      },

      {
        dataProcessor: 'Auth0',
        purpose:
          'This cookie is crucial for the functionality and security of web applications using Auth0 for authentication. It helps manage user sessions, enabling single sign-on (SSO), multi-factor authentication (MFA), and attack protection capabilities.',
        dataProcessorPrivacyPolicy: {
          label: 'Auth0 Data Privacy and Compliance',
          link: 'https://auth0.com/docs/secure/data-privacy-and-compliance',
        },
        expiry: '3 days',
        cookieName: 'auth0',
        provider: 'Auth0',
      },

      {
        dataProcessor: 'Auth0',
        purpose:
          'This cookie is used to remember the authentication state with Auth0 across multiple page tabs and page refreshes. It helps minimize unnecessary log-ins for a better user experience.',
        dataProcessorPrivacyPolicy: {
          label: 'Auth0 Data Privacy and Compliance',
          link: 'https://auth0.com/docs/secure/data-privacy-and-compliance',
        },
        expiry:
          'This cookie is a session cookie, meaning it expires when the browser tab is closed.',
        cookieName: 'auth0.<unique_identifier>.is.authenticated',
        provider: 'Auth0',
        note: '<unique_identifier> represents a unique, auto-generated string that changes with each session',
      },

      {
        dataProcessor: 'Auth0',
        purpose:
          'This cookie serves as a fallback for single sign-on (SSO) on browsers that do not support the SameSite=None attribute. It ensures that SSO functionality remains intact even on older browsers.',
        dataProcessorPrivacyPolicy: {
          label: 'Auth0 Data Privacy and Compliance',
          link: 'https://auth0.com/docs/secure/data-privacy-and-compliance',
        },
        expiry: '3 days',
        cookieName: 'auth0_compat',
        provider: 'Auth0',
      },
      {
        dataProcessor: 'Microsoft',
        purpose:
          'This cookie is used to identify users and track their interactions with Microsoft services. It helps in providing personalized experiences and improving service performance.',
        dataProcessorPrivacyPolicy: {
          label: 'Microsoft Privacy Statement – Microsoft privacy',
          link: 'https://privacy.microsoft.com/en-gb/privacystatement',
        },
        expiry: '1 year',
        cookieName: 'did',
        provider: 'Microsoft',
      },
      {
        dataProcessor: 'Auth0',
        purpose:
          'This cookie serves as a fallback for device identification and anomaly detection on browsers that do not support the SameSite=None attribute. It helps maintain security and attack protection capabilities.',
        dataProcessorPrivacyPolicy: {
          label: 'Auth0 Data Privacy and Compliance',
          link: 'https://auth0.com/docs/secure/data-privacy-and-compliance',
        },
        expiry: '1 year',
        cookieName: 'did_compat',
        provider: 'Auth0',
      },
    ],
  },
  {
    title: 'Statistical',
    description:
      'Statistical cookies help the website owner understand how visitors interact with the website by collecting and reporting information.',
    cookies: [
      {
        dataProcessor: 'Google Analytics',
        purpose:
          "This cookie is used to distinguish unique users by assigning a randomly generated number as a client identifier. It is included in each page request in a site and used to calculate visitor, session, and campaign data for the site's analytics reports.",
        dataProcessorPrivacyPolicy: {
          label: "Google's Privacy Policy | Google",
          link: 'https://policies.google.com/privacy',
        },
        expiry: 'The _ga cookie expires after 2 years.',
        cookieName: '_ga',
        provider: 'Google Analytics',
      },
      {
        dataProcessor: 'Google Analytics',
        purpose:
          "This cookie is used to distinguish unique users by assigning a randomly generated number as a client identifier. It is included in each page request in a site and used to calculate visitor, session, and campaign data for the site's analytics reports.",
        dataProcessorPrivacyPolicy: {
          label: "Google's Privacy Policy | Google",
          link: 'https://policies.google.com/privacy',
        },
        expiry: 'This cookie expires after 2 years.',
        cookieName: '_ga_<unique_identifier>',
        provider: 'Google Analytics',
        note: '<unique_identifier> represents a unique, auto-generated string that is used to differentiate between different instances of the same type of cookie.',
      },
    ],
  },
]
